// extracted by mini-css-extract-plugin
export default {"containerSegment":"ContainerSegment_containerSegment__HWb2Z"};